import {PageBlocks} from "@/store/user_management/partner_user_roles/types";

export interface PartnerUsersState {
  partnerUsers: PartnerUserItem[];
  partnerUserItem?: PartnerUserItem;
}

export interface PartnerUserItem {
  id?: number;
  name?: string;
  email?: string;
  partner?: string;
  status?: number;

  password?: string;
  confirm_password?: string;
  show_messages_text?: number;
  is_check_pass?: number;
  timezone_id?: number;
  // timezone_name?: string;
  role_id?: number;
  partner_user_page_blocks?: PageBlocks[]
}

export class PartnerUserItemImpl implements PartnerUserItem {
  id?: number;
  name?: string;
  email?: string;
  partner?: string;
  status?: number;
  show_messages_text?: number;
  is_check_pass?: number;
  password?: string;
  confirm_password?: string;
  timezone_id?: number;
  // timezone_name?: string;
  role_id?: number;
  partner_user_page_blocks?: PageBlocks[];

  constructor() {
    this.status = 0;
    this.show_messages_text = 1;
    this.is_check_pass = 0;
    this.timezone_id = 4;
    // this.timezone_name = "UTC+3";
    this.role_id = undefined;
    this.partner_user_page_blocks = [];
  }
}

export class PartnerUserFilter {
  id?: number;
  name?: string;
  email?: string;
  partner?: string;
  status?: number;
  role_id?: number;
  page_number: number =  1;
}

export interface Timezone {
  id: number;
  name: string;
}
